import { Banknote, FileText } from 'lucide-react'
import { cn } from '@/lib/utils'
import { PURCHASING_STRINGS } from './purchasingStrings'

export type PaidFrom = 'vendor_credit' | 'petty_cash'

const S = PURCHASING_STRINGS.paidFrom

/** Kitchen flow lane D: two big buttons — "on credit" (today: a vendor bill
 *  is drafted) or "petty cash" (paid now, no bill; shows in the petty-cash
 *  report). Only rendered when the kitchen flow is on. */
export function PaidFromChoice({ value, onChange }: { value: PaidFrom; onChange: (v: PaidFrom) => void }) {
  const opt = (v: PaidFrom, Icon: typeof Banknote, label: string, help: string) => (
    <button
      type="button"
      aria-pressed={value === v}
      onClick={() => onChange(v)}
      className={cn(
        'flex min-h-16 flex-1 items-center gap-3 rounded-lg border-2 px-3 py-2 text-left transition-colors',
        value === v ? 'border-primary bg-primary/5' : 'border-border hover:bg-muted/40',
      )}
    >
      <Icon className="h-5 w-5 shrink-0" aria-hidden />
      <span>
        <span className="block text-sm font-semibold">{label}</span>
        <span className="block text-xs text-muted-foreground">{help}</span>
      </span>
    </button>
  )
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">{S.label}</p>
      <div className="flex flex-col gap-2 sm:flex-row">
        {opt('vendor_credit', FileText, S.credit, S.creditHelp)}
        {opt('petty_cash', Banknote, S.cash, S.cashHelp)}
      </div>
    </div>
  )
}
